import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import CellHelper from './cellHelper.js';

/**
 * Component for showing text w/ line breaks
 *
 */
export default React.createClass({
  displayName: 'LineBreakText',

  mixins: [PureRenderMixin],

  propTypes: {
    children: React.PropTypes.string.isRequired,
  },

  render() {
    let text = this.props.children;

    return <div>{CellHelper.getNodesWithLineBreaks(text)}&nbsp;</div>;
  },
});
